/* app/providers/NewBuildNotice.jsx — тост «Вышла новая версия» в открытой вкладке.

   Сверку сборки ведёт lib/buildWatch.js (когда, как часто, почему мимо apiFetch). Здесь —
   только тост: постоянный (duration 0), с кнопкой «Обновить»; закрыть его можно крестиком —
   про ту же сборку вкладка больше не скажет. Перезагрузка — только по кнопке: грязную форму
   сторожит beforeunload (UnsavedChangesProvider), браузер спросит сам. */

import React from 'react';
import { useToast } from './ToastProvider.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { startBuildWatch } from '../../lib/buildWatch.js';

  const { useEffect, useRef } = React;

  function NewBuildNotice() {
    const toast = useToast();
    const toastRef = useRef(toast);
    toastRef.current = toast;

    useEffect(() => {
      if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;
      let toastId = null;
      const stop = startBuildWatch({
        win: window,
        doc: document,
        fetchImpl: typeof window.fetch === 'function' ? window.fetch.bind(window) : null,
        onNewBuild: () => {
          const t = toastRef.current;
          if (!t || typeof t.show !== 'function') return;
          if (toastId != null) t.dismiss(toastId);
          toastId = t.show(
            <span className="stack stack-4">
              <span>Вышла новая версия Ресториума — обновите страницу, чтобы получить исправления.</span>
              <span className="cluster cluster-2">
                <Button size="sm" variant="primary" onClick={() => window.location.reload()}>Обновить</Button>
              </span>
            </span>,
            'muted', 0,
          );
        },
      });
      return stop;
    }, []);

    return null;
  }

export { NewBuildNotice };
